module.exports = __webpack_public_path__ + "img/groupofpeople@2x.09707f9e.webp";